import { styled } from "@mui/material/styles";
import ListItemText from "@mui/material/ListItemText";

// Styled component with dynamic `open` prop
const SideBarListItemText = styled(ListItemText, {
  shouldForwardProp: (prop) => prop !== "open",
})<{ open: boolean }>(({ open }) => ({
  opacity: open ? 1 : 0,
}));

export default SideBarListItemText;
